import { render, staticRenderFns } from "./TgSpecialHeaderBar.vue?vue&type=template&id=2d9eca46&"
import script from "./TgSpecialHeaderBar.vue?vue&type=script&lang=js&"
export * from "./TgSpecialHeaderBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports